// Games announce their own milestones; lib/analytics turns them into coarse events in site.ts.
export interface GameEventDetail {
  type: "first_move" | "end"
  ruleset: string
  outcome?: "win" | "loss" | "new_game" | "abandon" // loss: games against the computer
  moves?: number
  undos?: number
  hints?: number
  deal?: string | number
  daily?: boolean
  input?: "tap" | "click" | "drag" | "keyboard"
}

export function gameEvent(detail: GameEventDetail): void {
  document.dispatchEvent(new CustomEvent("dt:game", { detail }))
}
